var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sc-form", {
        ref: "credentialsForm",
        attrs: { autocomplete: "off" },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("main", { staticClass: "finishContent" }, [
                  _c("h1", { staticClass: "title" }, [
                    _vm._v("Integração concluida com sucesso")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "spanCheck" }, [_vm._v("✓")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "feedback" }, [
                    _vm._v(
                      "Seu feedback é fundamental! Por favor, participe da pesquisa sobre esse processo clicando\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "blank",
                          href:
                            "https://docs.google.com/forms/d/e/1FAIpQLScI3zUeSWPTCDtWkkKM_jm3VSgeRFsxHUHjvyxGF7z0SYp2VQ/viewform"
                        }
                      },
                      [_vm._v("aqui")]
                    )
                  ])
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c("sc-button", {
                  staticClass: "finishIntegration",
                  attrs: {
                    id: "buttonFinish",
                    text: "Finalizar",
                    theme: "primary",
                    type: "submit"
                  },
                  on: { click: _vm.finishProcess }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6868b46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6868b46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScFinished.vue
// module id = null
// module chunks = 